import { activatePro, deactivatePro } from './presets.js'

const LS_ACTIVATE_URL   = 'https://api.lemonsqueezy.com/v1/licenses/activate'
const LS_VALIDATE_URL   = 'https://api.lemonsqueezy.com/v1/licenses/validate'
const LS_DEACTIVATE_URL = 'https://api.lemonsqueezy.com/v1/licenses/deactivate'

function getInstanceId() {
  let id = localStorage.getItem('printcalc_instance_id')
  if (!id) {
    id = crypto.randomUUID()
    localStorage.setItem('printcalc_instance_id', id)
  }
  return id
}

function storedKey() {
  return localStorage.getItem('printcalc_license_key') ?? ''
}

export async function activateLicense(key) {
  try {
    const res = await fetch(LS_ACTIVATE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        license_key: key,
        instance_name: 'PrintCalc Browser',
      }),
    })
    const data = await res.json()
    if (data.activated) {
      localStorage.setItem('printcalc_license_key', key)
      localStorage.setItem('printcalc_instance_id', data.instance.id)
      activatePro()
      return { ok: true }
    }
    return { ok: false, error: data.error ?? 'Activation failed' }
  } catch {
    return { ok: false, error: 'Network error — check your connection' }
  }
}

export async function validateStoredLicense() {
  const key = storedKey()
  if (!key) return false
  try {
    const res = await fetch(LS_VALIDATE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        license_key: key,
        instance_id: getInstanceId(),
      }),
    })
    const data = await res.json()
    if (data.valid) {
      activatePro()
      return true
    }
    deactivatePro()
    return false
  } catch {
    return localStorage.getItem('printcalc_pro') === 'true'
  }
}

export async function deactivateLicense() {
  const key = storedKey()
  if (!key) return { ok: false }
  try {
    await fetch(LS_DEACTIVATE_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: new URLSearchParams({
        license_key: key,
        instance_id: getInstanceId(),
      }),
    })
  } catch { /* best effort */ }
  localStorage.removeItem('printcalc_license_key')
  localStorage.removeItem('printcalc_instance_id')
  deactivatePro()
  return { ok: true }
}